<template>
  <div>
    <v-container>
      <!-- <div class="text-xs-right">
        <span>
          <v-btn
            :loading="exportloading"
            @click="exportData"
            outline
            color="grey"
            class="ma-0 mb-0"
          >
            <em class="fas fa-file-export mr-1"/>
            {{ $t('export') }}
          </v-btn>
        </span>
      </div> -->
      <div class="mb-2">
        <date-filter
          @changeDate="getRunner"
          :defaultFilter="'this_month'"
          v-model="selectedDate"
        ></date-filter>
      </div>
      <v-layout row wrap>
        <v-flex xs4 class="pr-1">
          <div>ชื่อโครงการ</div>
          <multiselect
            v-model="filter.project"
            :options="projects"
            :allow-empty="false"
            :searchable="false"
            @input="getRunner"
            selectLabel
            placeholder="เลือกโครงการ"
            selectedLabel
            deselect-label
          ></multiselect>
        </v-flex>
        <v-flex xs6>
          <div>ชื่อผู้สมัคร</div>
          <div class="form-control">
            <input type="text" placeholder="ค้นหา" v-model="filter.name" @keyup.enter="getRunner" />
          </div>
        </v-flex>
        <v-flex xs2>
          <v-btn
            :loading="loading"
            @click="getRunner"
            large
            outline
            class="mt-4"
            color="primary"
            icon
          >
            <v-icon>search</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <div>
        <v-pagination
          :total-visible="15"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>

        <!-- <Pagination :limit="10" :total="total" @onChange="onChangePage"> -->
        <v-data-table
          expand
          hide-actions
          :pagination.sync="paginationsync"
          :loading="loading"
          :headers="headers"
          :items="data"
          class="elevation-1 scgallrenttable"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  paginationsync.descending ? 'desc' : 'asc',
                  header.value === paginationsync.sortBy ? 'active' : ''
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                <div>
                  <v-btn
                    v-if="props.item.status == 'Approve'"
                    @click="reject(props.item)"
                    color="primary"
                    >Reject</v-btn
                  >
                  <v-btn
                    v-else
                    @click="reject(props.item)"
                    depressed
                    color="#eee"
                    style="color: grey"
                    >Rejected</v-btn
                  >
                </div>
              </td>
              <td class="text-xs-center">{{ props.item.project_name }}</td>
              <td class="text-xs-center">{{ props.item.ebib }}</td>
              <td class="text-xs-center" style="white-space: nowrap">
                {{ props.item.name }}
              </td>
              <td class="text-xs-center">{{ props.item.goal }}</td>
              <td class="text-xs-center">
                {{
                  props.item.running_result ? parseFloat(props.item.running_result).toFixed(2) : '-'
                }}
              </td>
              <td
                style="cursor: pointer"
                @click="showEditDistance(props.item)"
                class="text-xs-center primary--text"
              >
                {{ props.item.distances
                }}<span><v-icon color="primary" size="15px">edit</v-icon></span>
              </td>

              <td class="text-xs-center">
                <v-img
                  @click="clickShowImage(props.item.photourl)"
                  v-if="props.item.photourl"
                  :src="props.item.photourl"
                ></v-img>
                <v-img v-else src="/static/img/empty-img-placeholder.png"></v-img>
              </td>
              <td class="text-xs-center">
                {{ props.item.timestamp | DateFormat('DD/MM/YYYY') }}
              </td>
            </tr>
          </template>
        </v-data-table>
        <!-- </Pagination> -->
      </div>
      <v-dialog v-model="showImage" width="700px">
        <v-card v-if="showImage">
          <div class="text-xs-right">
            <v-btn @click="showImage = ''" icon><v-icon>close</v-icon></v-btn>
          </div>
          <v-card-text>
            <div><v-img :src="currentImg"></v-img></div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog width="400px" persistent v-model="showEdit">
      <v-card>
        <div class="pa-3">
          <div style="font-size: 22px">แก้ไขผลวิ่ง<v-icon>edit</v-icon></div>
          <div class="form-control mt-3">
            <input type="number" v-model="editinput" />
          </div>
          <div class="text-xs-center">
            <v-btn :loading="saveloading" @click="cancelEdit" outline color="grey">{{
              $t('cancel')
            }}</v-btn>
            <v-btn :loading="saveloading" @click="saveEdit" depressed color="primary">{{
              $t('Save')
            }}</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import Pagination from '@/components/elements/Pagination2.vue'
import moment from 'moment'
import * as XLSX from 'xlsx'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'

export default {
  components: {
    Multiselect,
    Pagination,
    DateFilter
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  data() {
    return {
      selectedDate: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD')
      },
      currentImg: '',
      showImage: '',
      exportloading: false,
      total: 0,
      data: [],
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      loading: false,
      paginationsync: { sortBy: 'timestamp', descending: true, rowsPerPage: 10 },
      headers: [
        { text: '', value: '', align: 'left', sortable: false },
        { text: 'โครงการ', value: 'project_name', align: 'left' },
        { text: 'E-BIB No', value: 'ebib', align: 'left' },
        { text: 'ชื่อ', value: 'name', align: 'left' },
        { text: 'ระยะทางที่กำหนด', value: 'goal', align: 'left' },
        { text: 'ระยะทางสะสม', value: 'running_result', align: 'left' },
        { text: 'ผลวิ่ง', value: 'distances', align: 'left' },
        { text: 'ภาพผลวิ่ง', value: 'photourl ', align: 'left' },
        { text: 'วันที่ส่ง', value: 'timestamp', align: 'left' }
      ],

      filter: {
        project: '',
        name: '',
        status: 'Success'
      },

      projects: [],
      saveloading: false,
      edititem: '',
      editinput: '',
      showEdit: false,
      statusOptions: ['Success', 'Not Success']
    }
  },
  async mounted() {
    await this.getProject()
    await this.getRunner()
  },
  methods: {
    saveEdit() {
      var data = {
        pageid: this.selectedBot.pageid,
        ebib: this.edititem.ebib,
        id: this.edititem.id, // id ของผลวิ่ง
        distances: this.editinput, // ผลวิ่งอันใหม่
        diff_distances: parseFloat(this.editinput) - parseFloat(this.edititem.distances) // ผลต่างระหว่างผลิวิ่งใหม่กับผลวิ่งเก่าได้มาจาก → ผลวิ่งใหม่ - ผลวิ่งเก่า
      }
      this.saveloading = true
      api.runkanadminupdatedistancesrunningresult(data, async (err, response) => {
        await this.getRunner()
        this.saveloading = false
        this.showEdit = false
      })
    },
    cancelEdit() {
      this.showEdit = false
    },
    showEditDistance(item) {
      this.edititem = item
      this.editinput = item.distances
      this.showEdit = true
    },
    reject(item) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            text: 'ยืนยันการเปลี่ยนสถานะ?',
            showCancelButton: true
          })
          .then((result) => {
            if (result.value) {
              var status = {
                old: item.status == 'Reject' ? 'Reject' : 'Approve',
                new: item.status == 'Reject' ? 'Approve' : 'Reject'
              }
              var data = {
                ebib: item.ebib,
                pageid: this.selectedBot.pageid,
                id: item.id,
                status: status.new,
                oldstatus: status.old
              }
              api.runkanadminupdaterunningresult(data, async (err, response) => {
                if (response.responsecode == 200) {
                  var index = this.data.findIndex((el) => el.id == item.id)
                  this.data[index].status = status.new
                  await this.$swal.fire({
                    text: 'สำเร็จ',
                    type: 'success'
                  })
                }
              })
            }
          })
      })
    },
    clickShowImage(img) {
      this.showImage = true
      this.currentImg = img
    },
    async exportData() {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filename = 'Participants'

      var json = []

      vm.exportloading = true
      var response = await this.getRunner('export')

      if (response) {
        var data = response
      }

      json = data.map((el) => {
        return {
          โครงการ: el.project_name ? el.project_name : '-',
          'E-bib No': el.ebib ? el.ebib : '-',
          สถานะ: el.status ? this.getStatus(el.status).label : '-',
          ชื่อ: el.memberinfo.first_name
            ? el.memberinfo.first_name + ' ' + el.memberinfo.last_name
            : '-',
          อีเมล: el.memberinfo.email ? el.memberinfo.email : '-',
          เบอร์โทร: el.memberinfo.phoneno ? el.memberinfo.phoneno : '-',
          ที่อยู่: el.memberinfo.address ? this.getFullAddress(el.memberinfo) : '-',
          วันที่สมัคร: el.registertimestamp
            ? moment(el.registertimestamp).format('DD/MM/YYYY')
            : '-'
        }
      })

      var dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, filename + '.xlsx')
      vm.exportloading = false
    },
    changeSort(column) {
      if (this.paginationsync.sortBy === column) {
        this.paginationsync.descending = !this.paginationsync.descending
      } else {
        this.paginationsync.sortBy = column
        this.paginationsync.descending = false
      }
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getRunner()
      }
    },
    getStatus(status) {
      if (status) return { label: 'วิ่งสำเร็จ', color: '#09b109' }
      else return { label: 'วิ่งไม่สำเร็จ', color: 'orange' }
    },
    getFullAddress(item) {
      return `${item.address} จังหวัด${item.province} เขต${item.district} แขวง${item.sub_district} ${item.postcode}`
    },

    getRunner(option) {
      var data = {
        pageid: this.selectedBot.pageid, // required

        project_name: this.filter.project, // required
        datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'),
        dateto: moment(this.selectedDate.end).format('YYYY-MM-DD'),
        status: this.filter.status, // Success, Not Success
        name: this.filter.name ? this.filter.name : null // Success, Not Success
      }
      if (option != 'export') {
        Object.assign(data, { limit: this.limit, offset: this.offset })
      }
      return new Promise((resolve) => {
        this.loading = true
        api.getrunkanattachrunningresultdashboard(data, (err, response) => {
          this.loading = false
          this.total = parseInt(response.total)
          var result = response.data.map((el) => {
            var memberinfo = {}
            if (el.memberinfo) {
              memberinfo = JSON.parse(el.memberinfo)
            }
            return { ...el, memberinfo }
          })
          if (option != 'export') {
            this.data = result
          }
          resolve(result)
        })
      })
    },
    getProject() {
      return new Promise((resolve) => {
        api.getrunkanprojects({ pageid: this.selectedBot.pageid }, (err, response) => {
          if (response.responsecode == 200) {
            this.projects = response.data.map((el) => el.project_name)
            this.filter.project = this.projects[0]
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/runkan/Attachedrunningresult.vue